import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@/components/ui/spinner';

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message, className = '' }) => {
  const { t } = useTranslation();
  return (
    <div
      data-test-id="loading-spinner"
      className={`flex items-center justify-center py-4 ${className}`}
    >
      <Spinner size="md" label={message ?? t('common.loading')} />
    </div>
  );
};
